function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import SelectComponent from './includes/SelectComponent';
import { setCookies, readCookies } from '../../../src/js/utilities/cookies';
var FILTER_SELECTOR = '[data-component="filterSelectMulti"]';
var TAG_CTA = '[data-element="tagCta"]';
var FilterSelectMulti = /*#__PURE__*/function (_SelectComponent) {
  function FilterSelectMulti(component, selector) {
    var _this;
    _classCallCheck(this, FilterSelectMulti);
    _this = _callSuper(this, FilterSelectMulti, [component, selector]);
    _this.component = component;
    _this.btn = _this.component.querySelector('[data-element="filterSelectSubmit"]');
    _this.btn.addEventListener('click', _this.submitResults.bind(_this));
    _this.parsedFromCookies = JSON.parse(readCookies('newsletterCategories'));
    _this.domain = _this.component.dataset.domain;
    _this.tagsBlock = document.getElementById('categoryTags');
    if (_this.parsedFromCookies) {
      _this.checkedValues = _this.getCheckedValues();
      setCookies('newsletterCategories', JSON.stringify(_this.checkedValues), 360, _this.domain);
    }
    if (!location.search && _this.parsedFromCookies && _this.parsedFromCookies.length > 0) {
      _this.addSpinner();
      _this.updateUrl(_this.parsedFromCookies);
    }
    _this.tagsBlock.addEventListener('click', _this.removeTags.bind(_this));
    return _this;
  }
  _inherits(FilterSelectMulti, _SelectComponent);
  return _createClass(FilterSelectMulti, [{
    key: "updateUrl",
    value: function updateUrl(params) {
      location.search = "?newsletterCategory=".concat(params.toString());
    }
  }, {
    key: "getCheckedValues",
    value: function getCheckedValues() {
      return Array.from(this.component.querySelectorAll('input[type="checkbox"]:checked')).map(function (checkbox) {
        return checkbox.value;
      });
    }
  }, {
    key: "removeTags",
    value: function removeTags(event) {
      event.target.matches(TAG_CTA) && this.addSpinner();
    }
  }, {
    key: "addSpinner",
    value: function addSpinner() {
      document.body.classList.add('is-loading');
    }
  }, {
    key: "submitResults",
    value: function submitResults() {
      var _this2 = this;
      var values = this.getCheckedValues();
      var jsonValues = JSON.stringify(values);
      this.addSpinner();
      setTimeout(function () {
        _this2.updateUrl(JSON.parse(jsonValues));
      }, 100);
      var valuesLength = values.length;
      this.inputField.textContent = valuesLength > 1 ? "".concat(valuesLength, " kategorier") : valuesLength === 1 ? "".concat(valuesLength, " kategori") : 'Alle kategorier';
      setCookies('newsletterCategories', jsonValues, 360, this.domain);
    }
  }]);
}(SelectComponent);
Array.from(document.querySelectorAll(FILTER_SELECTOR)).forEach(function (filter) {
  new FilterSelectMulti(filter, FILTER_SELECTOR);
});